import styled from '@emotion/styled'
import { Image as MaxxiaImage } from 'Maxxia/images'
import { Container } from 'react-bootstrap'

interface IInputProps {
  isActive: boolean
}

export const testRadio = styled.input`
  label: testRadio;
  height: 17px;
  width: 17px;
  accent-color: ${(props) => props.theme.colors.primary};
  margin-top: 20px;
  margin-left: 15px;
`

export const labelDiv = styled.div`
  label: labelDiv;
  text-align: left;
  margin-left: 12px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.textLightblack
      : props.theme.colors.textDarkblack};
`

export const RadioOptionDiv = styled.div<IInputProps>`
  label: RadioOptionDiv;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  width: 100%;
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  padding: 6px;
  background-color: ${(props) => (props.isActive ? '#f7f7f7' : 'white')};
  cursor: pointer;
`

export const heading = styled.h2`
  label: heading;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '600' : '800')};
  font-size: ${(props) => (props.theme.brand === 'Maxxia' ? '37px' : '32px')};
  color: ${(props) => props.theme.colors.textDarkblack};
`

export const body = styled.p`
  label: body;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.textLightblack
      : props.theme.colors.textDarkblack};
`

export const enterCodeHeading = styled.h2`
  label: enterCodeHeading;
  font-size: 32px;
  padding: 20px;
  font-weight: ${(props) => (props.theme.brand === 'Maxxia' ? '600' : '800')};
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack} !important;
`

export const enterCodeBody = styled.p`
  label: body;
  text-align: center;
  margin-bottom: 24px;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack};
`

export const CommonContainer = styled(Container)`
  margin-top: ${(props) => (props.theme.brand === 'Maxxia' ? '95px' : '40px')};
  border-radius: 0.3rem;
  max-width: 755px;
  min-width: 293px;
  padding: ${(props) => (props.theme.brand === 'Maxxia' ? '54px 18px' : '3rem')};
  background-color: white;

  @include media-breakpoint-up(md) {
    max-width: 755px;
  }

  @media (max-width: 719px) {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
    padding-top: 40px !important;
  }

  p {
    lineheight: 1.1;
  }
`

export const ReceiveOptionsP = styled.p`
  label: ReceiveOptionsP;
  margin-top: 18px;
  line-height: 1.1;
`

export const ResendLink = styled.span`
  label: ResendLink;
  color: ${(props) =>
    props.theme.brand === 'Maxxia'
      ? props.theme.colors.grey2
      : props.theme.colors.textDarkblack},
  text-decoration: underline;
  font-weight: 700;
`

export const MaxxiaLogoContainer = styled.div`
  label: MaxxiaLogoContainer;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const MaxxiaLogo = styled(MaxxiaImage)`
  label: MaxxiaLogo;
  position: absolute;
  top: 30px;
  z-index: 1;
`

export const MaxxiaBGLogin = styled.div`
  label: MaxxiaBGLogin;
  width: 100%;
  height: 100%;
  z-index: -1;
  position: absolute;
  max-height: 398px;
  &__overlay {
    top: 0;
    height: 398px;
    width: 100%;
    background-image: url('Maxxia/images/maxxia-xx.1e4bc878.png');
    background-position: center 0;
    background-repeat: no-repeat;
    background-size: contain;
    z-index: -1;
    position: absolute;
  }
  &__box {
    background-color: $maxxia-brand;
    width: 100%;
    position: absolute;
    height: 200px;
    z-index: -2;
    &:after {
      content: '';
      position: absolute;
      left: 0;
      top: 200px;
      border-top: 40vh solid $maxxia-brand;
      border-left: 50vw solid transparent;
      border-right: 50vw solid transparent;
    }
  }

  @media (max-width: 719px) {
    top: -30px;
  }
`

export const RemServContainer = styled.div`
  label: RemServContainer;
  max-width: 1110px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
`

export const RemServImageContainer = styled.div`
  label: RemServImageContainer;
  position: absolute;
  top: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;

  .remserv-logo {
    height: 60px;
    position: absolute;
    margin: 0 auto;
    top: 10px;
  }
`
